export default __webpack_public_path__ + "dea9a89848630dbe5288e6a4d7ed95ba.glb";